import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface CompetitionTypesState {
  list: any[];
}

const initialState: CompetitionTypesState = {
  list: [],
};

export const competitionTypesSlice = createSlice({
  name: 'competitionTypes',
  initialState,
  reducers: {
    setCompetitionTypes: (state, action: PayloadAction<any[]>) => {
      state.list = action.payload;
    },
    clearCompetitionTypes: (state) => {
      state.list = [];
    },
  },
});

export const { setCompetitionTypes, clearCompetitionTypes } = competitionTypesSlice.actions;

export default competitionTypesSlice.reducer;